
<collapsible-section
  class="collapse-item"
  :id="`objectModelLinkedSubmissionsCollapse-${dropdownControlId}`"
  control-name="objectModelLinkedSubmissionsCollapse"
  :is-open="false"
>
  <template #section-header>
    Linked Submissions
  </template>

  <template #section-contents>
    <section-fields
      :q="q"
      icon-glyph="form"
      :handler="handler"
      :section="linkedFormsSection"
      :select-additional-parameters="selectionArguments"
      @select="select"
    ></section-fields>
  </template>
</collapsible-section>
